<template>
  <div
    class="menu-logo bg-white rounded-pill"
    style="
      box-shadow: 0.5px 0.5px 5px rgba(0, 0, 0, 0.2), -1px 2px 5px rgba(0, 0, 0, 0.2) !important;
    ">
    <div class="view-navbar-brand">
      <span class="view-navbar-logo">
        <a
          name="logolink"
          class="view-navbar-link"
          style="display: flex; justify-content: center; align-items: center;"
          :href="href">
          <img
            :src="logo"
            :style="{  width: width, maxWidth: 'inherit !important', maxHeight: 'inherit !important', alignSelf: 'center !important;' }"
            :alt="alt" />
        </a>
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref } from 'vue';
  import { defineProps, watch } from 'vue';

  const props = defineProps({
    logo: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      required: false,
      default: 'Puga&Asociados-Logo',
    },
    href: {
      type: String,
      required: false,
      default: '/',
    },
  });

  const logolink = document.querySelector('a[name="logolink"]');
  logolink?.addEventListener('click', (event) => {
    event.preventDefault();
    window.location.href = props.href;
  });

  const innerwidth = ref(window.innerWidth);
  const width = ref('calc(100vmin * .21)');

  watch(innerwidth, (newWidth) => {
    if (newWidth <= 425) {
      width.value = '2.95rem';
    } else if (newWidth <= 768) {
      width.value = '3.95rem';
    } else if (newWidth <= 1024) {
      width.value = '4.5rem !important';
    } else if (newWidth <= 1440) {
      width.value = '5.25rem';
    } else {
      width.value = '5rem';
    }
  });
</script>